import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import usersModule from './modules/users/users'
import experimentsModule from './modules/experiments/experiments'
import categoriesModule from './modules/categories/categories'
import institutionsModule from './modules/institutions/institutions'
import chatbotModule from './modules/chatbot/chatbot'
import rolesModule from './modules/roles/roles'
import logsModule from './modules/logs/logs'
import versionsModule from './modules/versions/versions'
import vrCodeModule from './modules/vrCode/vrCode'
import activitiesModule from './modules/activities/activities'
import imagesModule from './modules/images/images'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    'app-ecommerce': ecommerceStoreModule,
    users: usersModule,
    experiments: experimentsModule,
    categories: categoriesModule,
    institutions: institutionsModule,
    chatbot: chatbotModule,
    roles: rolesModule,
    versions: versionsModule,
    vrCode: vrCodeModule,
    activities: activitiesModule,
    images: imagesModule,
    logs: logsModule,
  },
  strict: process.env.DEV,
})
